import validation from '@/validators/accountValidationService'

export default (errorMessage) => (value) => {
  return validation.isPhoneNumberValid(value) || errorMessage
}
